// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__8WnFR","Label":"Tooltip_Label__1dZxq","Value":"Tooltip_Value__3YNht","Norm":"Tooltip_Norm__3OPwJ"};